export function getFullArray(arrays) {
  const result = arrays.sort((a, b) => {
    const aLength = a?.length ?? 0;
    const bLength = b?.length ?? 0;
    return bLength - aLength;
  });
  return result[0] ?? [];
}
